export class InvoiceModel {
  id: number
  total_ex: number
  total_inc: number
  credit: boolean

  constructor(invoice) {
    this.id = invoice.id
    this.total_ex = invoice.total_ex
    this.total_inc = invoice.total_inc
    this.credit = invoice.credit
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/invoice.model.ts